import { tokens } from '@fluentui/react-components';

/**
 * Helpers for the E1 dashboard W-o-W trend subtitle on the Filed tile.
 * `trendLabel` takes an injected `t` so the helper stays unit-testable
 * without an i18n provider; tests can pass an identity-style stub.
 */

/**
 * Filed-this-week vs filed-last-week → Fluent token color.
 * Greater than → green, less than → red, equal → neutral.
 */
export function trendColor(thisWeek: number, lastWeek: number): string {
  if (thisWeek > lastWeek) return tokens.colorPaletteGreenForeground1;
  if (thisWeek < lastWeek) return tokens.colorPaletteRedForeground1;
  return tokens.colorNeutralForeground3;
}

export type TFn = (k: string, opts?: Record<string, unknown>) => string;

/**
 * Translation-driven label for the trend subtitle. The `t` parameter is
 * injected (caller supplies useTranslation()'s `t`) so the helper has no
 * React/i18next runtime dependency and is trivially testable.
 *
 * Returned i18n keys (for caller reference):
 *   - dashboardPage.stats.filedTrendUnchanged  (when delta === 0)
 *   - dashboardPage.stats.filedTrendUp         (when delta > 0)
 *   - dashboardPage.stats.filedTrendDown       (when delta < 0)
 */
export function trendLabel(thisWeek: number, lastWeek: number, t: TFn): string {
  const delta = thisWeek - lastWeek;
  if (delta === 0) {
    return t('dashboardPage.stats.filedTrendUnchanged', { count: thisWeek });
  }
  if (delta > 0) {
    return t('dashboardPage.stats.filedTrendUp', { count: thisWeek, delta });
  }
  return t('dashboardPage.stats.filedTrendDown', { count: thisWeek, delta: Math.abs(delta) });
}
